/* Phase 2-6 surfaces — visible in the Growth OS nav so the structure is
 *  in place from day one, but explicitly marked as not yet built. Each
 *  one names what it will do and which Phase it lands in. */

interface Props {
  title: string;
  phase: string;
  description: string;
  bullets?: string[];
}

export function GrowthPlaceholder({ title, phase, description, bullets }: Props) {
  return (
    <div className="sg-panel" style={{ maxWidth: 720 }}>
      <div className="sg-panel-pad">
        <div className="sg-eyebrow" style={{ fontSize: 11, color: "var(--sg-ink-4)", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 6 }}>
          {phase}
        </div>
        <h2 style={{ fontSize: 22, margin: "0 0 8px" }}>{title}</h2>
        <p style={{ color: "var(--sg-ink-3)", fontSize: 14, marginBottom: 12 }}>{description}</p>
        {bullets && bullets.length > 0 && (
          <ul style={{ color: "var(--sg-ink-3)", fontSize: 13.5, lineHeight: 1.7, paddingLeft: 18 }}>
            {bullets.map((b, i) => <li key={i}>{b}</li>)}
          </ul>
        )}
      </div>
    </div>
  );
}

export const GrowthOutreachPage = () => (
  <GrowthPlaceholder
    title="Outreach"
    phase="Phase 3"
    description="Generate, review, and send the first email in a campaign. Phase 1 ships the lead pipeline; outreach is the next layer."
    bullets={[
      "Per-lead message generator with workspace-tuned tone",
      "Spec-checked drafts (length, opt-out, identity, salesy vocabulary)",
      "Manual approval gate before any email leaves",
      "Sequence definitions: email 1 / 2 / 3, with min-gap rules",
    ]}
  />
);

export const GrowthRepliesPage = () => (
  <GrowthPlaceholder
    title="Replies"
    phase="Phase 4"
    description="Inbox of replies threaded against leads. Phase 4 wires the Gmail/SMTP listener and the AI classifier."
    bullets={[
      "Reply classification: interested / question / referral / not now / unsubscribe / objection / out of office / bounce",
      "Suggested next action per reply",
      "Auto-stop sequence on reply or unsubscribe",
    ]}
  />
);

export const GrowthCallsPage = () => (
  <GrowthPlaceholder
    title="Calls"
    phase="Phase 6"
    description="Scheduled discovery calls + post-call notes + objection tracker."
    bullets={[
      "Call prep brief generated per lead",
      "Notes captured with structured fields (pain, objections, decision process)",
      "Auto-suggest follow-up email + pilot proposal",
    ]}
  />
);

export const GrowthPilotsPage = () => (
  <GrowthPlaceholder
    title="Pilots"
    phase="Phase 6"
    description="Track active trials and paid pilots through to conversion."
    bullets={[
      "Pilot type: paid / 30-day / founder-approved free trial",
      "Onboarding checklist + activity rollup",
      "Conversion outcome + reason-lost",
    ]}
  />
);

export const GrowthReportsPage = () => (
  <GrowthPlaceholder
    title="Reports"
    phase="Phase 5"
    description="Funnel + cohort views from the leads, outreach, and pilots tables."
    bullets={[
      "Weekly founder report (Mondays)",
      "Lead source ROI",
      "Best subject lines + opening lines + CTAs",
      "Conversion by score, practice area, location",
    ]}
  />
);
